import ZeissButton from '@components/button';
import ZeissModal from '@components/zeiss-modal';
import { Space } from 'antd';
// import './index.scss';
export const NextNoticePopup = ({ open, handleCancel, handleOk }: any) => {
  return (
    <ZeissModal
      open={open}
      width={520}
      centered
      footer={null}
      onCancel={handleCancel}
    >
      <div className="pc-forwardAnn-layout">
        <div className="pc-forwardAnn-title">继续处理下一个公告</div>
        <div>处理公告后，可以确认公告处理完成。</div>
        <div className="pc-subLayout" style={{ padding: 0 }}>
          <Space className="pc-matter-createAnn-footer" size="middle">
            <ZeissButton className="pc-normal-btn" onClick={handleCancel}>
              取消
            </ZeissButton>
            <ZeissButton
              type="primary"
              className="pc-confirm-btn"
              onClick={handleOk}
            >
              去处理
            </ZeissButton>
          </Space>
        </div>
      </div>
    </ZeissModal>
  );
};
